module.exports = __webpack_public_path__ + "static/media/add.7fa50109.svg";